import React from 'react'
import DisclaimerMain from '../../components/disclaimerMain/DisclaimerMain'
import Navbar2 from '../../components/navbar2/navbar2'
import ColumnHero from '../../components/columnHero/ColumnHero'

import DisclaimerRow from '../../components/disclaimerRow/DisclaimerRow'


import TopComponent from '../../components/topComponent/TopComponent'

const Disclaimer = () => {

  const  navStyles={ backgroundColor: "#fff", position: "relative"}

  return (
    <div className="homeContainer">
    <TopComponent/>
    <Navbar2 styles2={navStyles}/>
    <DisclaimerMain/>

<ColumnHero/>

<DisclaimerRow/>

    
    </div>
  )
}

export default Disclaimer